import React from "react";

// const images = [
//   "01.png",
//   "02.png",
//   "03.png",
//   "04.png",
//   "05.png",
//   "06.png",
//   "07.png",
//   "08.png",
//   "09.png",
//   "10.png",
//   "11.png",
//   "12.png",
//   "13.png",
//   "14.png",
//   "15.png",
//   "16.png",
//   "17.png",
//   "18.png",
//   "19.png",
//   "20.png",
//   "21.png",
//   "22.png",
//   "23.png",
//   "24.png",
//   "25.png",
//   "26.png",
//   "27.png",
//   "28.png",
//   "29.png",
//   "30.png",
//   "31.png",
//   "32.png",
//   "33.png",
//   "34.png",
// ];
const images = [
  "01.png",
  "02.png",
  "03.png",
  "04.png",
  "05.png",
  "06.png",
  "07.png",
  "08.png",
  "09.png",
  "10.png",
  "11.png",
  "12.png",
  "13.png",
  "14.png",
  "15.png",
  "16.png",
  "17.png",
  "18.png",
  "19.png",
  "20.png",
  "21.png",
  "22.png",
  "23.png",
  "24.png",
  "25.png",
  "26.png",
  "27.png",
  "28.png",
  "29.png",
  "30.png",
  "31.png",
  "32.png",
  "33.png",
  "34.png",
];
export default function Partners() {
  return (
    <>
      <section className=" pt-20 w-full overflow-hidden p-5 text-center">
        {/* <div>
          <span className="text-[#9A9A9A]">Clients & partners</span>
          <h4 className=" font-medium">Clients</h4>
        </div> */}
        {/* <br/> */}
        {/* <div className="flex overflow-hidden mt-8">
          <div className="flex animate-loop-scroll">
            {images.map((image, index) => (
              <img
                src={require(`../../../assets/About/ClientsLogo/${image}`)}
                key={index}
                className="max-w-none w-32 h-32 object-contain border border-gray-color p-2 md:p-4 hover:bg-gray-color"
                alt="Clients Image"
              />
            ))}
          </div>
          <div className="flex animate-loop-scroll" aria-hidden="true">
            {images.map((image, index) => (
              <img
                src={require(`../../../assets/About/ClientsLogo/${image}`)}
                key={index}
                className="max-w-none w-32 h-32 object-contain border border-gray-color p-2 md:p-4 hover:bg-gray-color"
                alt="Clients Image"
              />
            ))}
          </div>
        </div> */}
        <div className="flex overflow-hidden">
          <div className="flex animate-loop-scroll-second">
            {images.map((image, index) => (
              <img
                src={require(`../../../assets/About/ClientsLogo/${image}`)}
                key={index}
                className="max-w-none w-32 h-32 object-contain p-2 md:p-4 hover:bg-gray-color"
                alt="Clients Image"
              />
            ))}
          </div>
          <div className="flex animate-loop-scroll-second" aria-hidden="true">
            {images.map((image, index) => (
              <img
                src={require(`../../../assets/About/ClientsLogo/${image}`)}
                key={index}
                className="max-w-none w-32 h-32 object-contain  p-2 md:p-4 hover:bg-gray-color"
                alt="Clients Image"
              />
            ))}
          </div>
        </div>
        {/* <div className="flex items-center justify-evenly gap-4 mt-8">
          {images.map((image, index) => (
            <img
              src={require(`../../../assets/About/ClientsLogo/new/${image}`)}
              key={index}
              className="max-w-none w-32 h-32 object-contain  p-2 md:p-4 hover:bg-gray-color"
              alt="Clients Image"
            />
          ))}
        </div> */}
        {/* <div className="flex flex-col items-center justify-center">
          <h4 className=" font-medium mb-6 flex-nowrap">Partners</h4>
          <div className="w-full flex-col md:flex-row flex  md:text-start items-center justify-center">
            <div className=" border border-gray-color p-5 w-full  md:w-1/4">
              <span className="text-sm">Philips</span>
              <img
                src={require("../../assets/About/Partner1.png")}
                className="w-full h-20 object-contain"
                alt="Philips"
              />
            </div>
            <div className=" border border-gray-color p-5 w-full md:w-1/4">
              <span className="text-sm">Neusoft Medical Systems</span>
              <img
                src={require("../../assets/About/Partner2.png")}
                className="w-full h-20 object-contain"
                alt="Neusoft Medical Systems"
              />
            </div>
          </div>
        </div> */}
      </section>
    </>
  );
}
